import React from "react";
import Head from "next/head";
import { Box } from "@chakra-ui/react";
import BusinessList from "@/components/main/businesslist";
import GoogleMapBanner from "@/components/main/googlemapbanner";
const UserDashboardPage = () => {
  return (
    <Box minH="100vh">
      <GoogleMapBanner />
      <BusinessList />
    </Box>
  );
};

export default UserDashboardPage;
